export class EnterNewPasswordPageState {
  public isSending: boolean;
  public error: object | null;

  constructor() {
    this.isSending = false;
    this.error = null;
  }
}
